import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

// 스타일링된 컴포넌트를 생성합니다.
const TutorialArea = styled.div`
  #clip-01 {
    --x: 12px;
    --y: 829px;
    --width: 1514px;
    --height: 453px;

    top: 0;
    left: 0;
    width: 1537px;
    height: 2000px;
  }

  #clip-02 {
    --x: 1px;
    --y: 829px;
    --width: 371px;
    --height: 453px;

    top: 0;
    left: 1537px;
    width: 383px;
    height: 2000px;
  }

  #text-01 {
    top: 758px;
    left: 40px;
  }
`;

const ServiceDetail03 = () => {
  const elementRef = useRef(null);

  useEffect(() => {
    if (elementRef.current) {
      window.scrollTo(0, elementRef.current.offsetTop - 90); // GNB height
    }
  }, []);

  return (
    <>
      <TutorialArea className='tutorial-area'>
        <div id="clip-01" className="clip-box">
          <div id="clip-01-hole" className="hole" />
          <div id="clip-01-border" className="border" />
        </div>

        <div id="clip-02" className="clip-box">
          <div id="clip-02-hole" className="hole" />
          <div id="clip-02-border" className="border" />
        </div>

        <div className="text-box">
          <div id="text-01" className="text" ref={elementRef} >IF you select the issue item, you can check action point and details about that</div>
        </div>
      </TutorialArea>
    </>
  );
};

export default ServiceDetail03;